import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import RouteContext from "../context/RouteContext";
import AppOutlet from "../components/AppOutlet";
import { State } from "../reducer";

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isInitialized } = useContext(RouteContext);
  const user = useSelector((state: State) => state.user);
  const fromBarista = location.state?.from?.pathname || "/ordering";
  const fromUserCafe = location.state?.from?.pathname || "/menuCafe";
  const fromAdminCafe = location.state?.from?.pathname || "/menuCafe-admin";
  const fromUserBar = location.state?.from?.pathname || "/order_bar";
  const fromAdminBar = location.state?.from?.pathname || "/order_bar";
  const fromUserClose = location.state?.from?.pathname || "/close-all";
  const fromAdminClose = location.state?.from?.pathname || "/close-all-admin";

  useEffect(() => {
    if (!isInitialized) return;
    if (!localStorage.access_token && !localStorage.refresh_token) {
      navigate("/login");
    } else {
      const checkBar = user?.isBarOpen;
      const checkCafe = user?.isCafeOpen;
      const roles: string = user?.role;
      if (roles === "admin" && checkBar === true && checkCafe === false) {
        navigate(fromAdminBar, { replace: true });
      }
      if (roles === "admin" && checkBar === false && checkCafe === true) {
        navigate(fromAdminCafe, { replace: true });
      }
      if (roles === "user" && checkBar === true && checkCafe === false) {
        navigate(fromUserBar, { replace: true });
      }
      if (roles === "user" && checkBar === false && checkCafe === true) {
        navigate(fromUserCafe, { replace: true });
      }
      if (roles === "admin" && checkBar === false && checkCafe === false) {
        navigate(fromAdminClose, { replace: true });
      }
      if (roles === "user" && checkBar === false && checkCafe === false) {
        navigate(fromUserClose, { replace: true });
      }
      if (roles === "barista") {
        navigate(fromBarista, { replace: true });
      }
    }
    // Only re-route when auth init/user changes; adding navigate/location-derived
    // fallbacks would re-trigger redirects on every navigation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized, user]);

  return (
    <main className="App">
      <AppOutlet />
    </main>
  );
};
export default Layout;
